import React from "react";
import ReactDOM from "react-dom";
import { Link, Routes, Route, useNavigate, Navigate, Outlet } from "react-router-dom";

import { Menu, MenuItem, MenuDivider, Icon } from "monday-ui-react-core";
import { Alert } from "monday-ui-react-core/dist/allIcons";

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";

import Loader from "../libs/loader.jsx";

import AccessToken from "../accessToken/accessToken.jsx";
import Tracket from "./tracket.jsx";

const E404 = () => (
    <div className="container-fluid">
        <h1>404</h1>
    </div>
);

class Settings extends React.Component
{
    constructor(props)
    {
        super(props);
        //console.log("Settings props",this.props);
        this.params = this.props.router.params;
        
        this.state = {
            'loading': false,
        };
        
        this.loader = React.createRef();
    }
    
    onLinkClick(e, target, ...args)
    {
        e.preventDefault();
        e.stopPropagation();
        
        //console.log("click", target);
        
        switch(target)
        {
            case 'tokens': this.props.router.navigate("/settings"); break;
            case 'tracket': this.props.router.navigate("/settings/tracket"); break;
            case 'error': this.props.router.navigate("/settings/error"); break;
            default: this.props.router.navigate("/"); break;
        }

        return false;
    };
    
    render()
    {
        var this_component = this;
        
        return (
            <Loader ref={this_component.loader}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                            <Menu size="small" className="w-100 pt-4">
                            <MenuItem title={<>Access Token {(this_component.props.auth.personalToken!=='' && this_component.props.auth.personalTokenValid===false)?<Icon icon={Alert} style={{'color': "var(--color-error)", 'verticalAlign': 'sub'}} iconSize="19" />:null}</>} onClick={(e) => this_component.onLinkClick(e,'tokens')} isInitialSelectedState />
                                <MenuDivider />
                                <MenuItem title={<>Tracket Token {(this_component.props.auth.tracketTokenValid===false)?<Icon icon={Alert} style={{'color': "var(--color-error)", 'verticalAlign': 'sub'}} iconSize="19" />:null}</>} onClick={(e) => this_component.onLinkClick(e,'tracket')} />
                            </Menu>
                        </div>
                        <div className="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10">

                            <Routes>
                                <Route path="/">
                                    <Route index element={<AccessToken />} />
                                    <Route path="/tracket" element={<Tracket />} />
                                    <Route path="/*" element={<E404 />} />
                                </Route>
                            </Routes>

                        </div>
                    </div>
                </div>
            
            
            
            </Loader>
        );
    }
}

Settings.defaultProps = {
};

export default withRouter(withAuth(Settings));

